<template>
  <div class="main-content">

    <customModal v-if="modalData" v-show="modalData" :onModalClose="closeModal" :onModalAccept="removeRecord"
                 :modalData="modalData"></customModal>

    <div class="card">
      <div class="card-body">
        <form @submit.prevent="newRecord">
          <div class="flex elements-m-2">
            <div class="mw_50">
              <DrugSearchNew
                ref="drugSelected"
              />
            </div>
            <div class="min-w-180">
              <select v-model="new_record.catalog_id" class="form-control">
                <option value="0">Все выгрузки</option>
                <option v-for="(catalog, id) in uploadCatalogs" :value="id">{{ catalog }}</option>
              </select>
            </div>
            <div class="min-w-180">
              <select v-model="new_record.site_id" class="form-control">
                <option value="0">Все проекты</option>
                <option v-for="(project, id) in $AllProjects" v-if="project.is_active" :value="id">{{
                    project.name
                  }}
                </option>
              </select>
            </div>
          </div>
          <div>
            <div class="form-check">
              <input type="checkbox" class="form-check-input" id="toGlobalList" v-model="noActualDate">
              <label class="form-check-label" for="toGlobalList">Бессрочная запись</label>
            </div>
            <div class="form-check">
              <input type="checkbox" class="form-check-input" id="ch_1" v-model="disableOnProject">
              <label class="form-check-label" for="ch_1">Деактивировать на проекте</label>
            </div>
          </div>
          <div class="flex" style="align-items: end;">
            <div class="">
              <div v-if="!noActualDate">
                <DateSelect ref="selectedDate"
                            :selectedDate="drugData.date"/>
              </div>
            </div>
            <input type="text" v-model="drugData.comment" placeholder="Комментарий к записи" class="form-control">
            <vue-ladda button-class="btn btn-info" data-style="zoom-in"
                       :loading="createLoading" type="submit">Создать
            </vue-ladda>
          </div>
        </form>
      </div>
    </div>

    <div class="card">
      <div class="card-body">
        <form @submit.prevent="getRecords(1)">
          <div class="flex elements-m-2">
            <div class="form-group">
              <label for="">Выгрузка</label>
              <select v-model="filter.catalog_id" class="form-control">
                <option value="0">Любой каталог</option>
                <option v-for="(catalog, id) in uploadCatalogs" :value="id">{{ catalog }}</option>
              </select>
            </div>
            <div class="form-group">
              <label for="">Проект</label>
              <select v-model="filter.site_id" class="form-control">
                <option value="0">Любой проект</option>
                <option v-for="(project, id) in $AllProjects" v-if="id" :value="id">{{ project.name }}</option>
              </select>
            </div>
            <div class="form-group">
              <label for="">Препарат</label>
              <input type="text" placeholder="аденурик..." v-model="filter.drug" class="form-control">
            </div>
            <div class="flex mb-3">
              <vue-ladda @clickkk="getRecords(1, true)" button-class="btn btn-success as_b" data-style="zoom-in"
                         :loading="loading" type="submit">Поиск
              </vue-ladda>
            </div>
          </div>
        </form>
        <hr>
        <div v-if="loading">
          <pulse-loader :loading="loading" :color="loadingColor" class="text-center"/>
        </div>
        <div v-else>
          <div v-if="!records">
            <h5>Записей не найдено</h5>
          </div>
          <div v-else>
            <table class="table table-sm table-hover">
              <thead>
              <tr>
                <th></th>
                <th>ID</th>
                <th>ЕГК</th>
                <th>Выгрузка</th>
                <th>Проект</th>
                <th>Препарат</th>
                <th>Актуальность</th>
                <th></th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="(record, index) in records">
                <td>{{ (index + 1) + (paginator ? ((paginator.current_page - 1) * paginator.per_page) : 0) }}</td>
                <td>{{ record.object_id || '' }}</td>
                <td>{{ record.drug && record.drug.egk }}</td>
                <td>{{ uploadCatalogs[record.extra_data.catalog_id] || 'Все выгрузки' }}</td>
                <td>
                  <p class="mb-0">{{
                      $AllProjects[record.extra_data.site_id] && $AllProjects[record.extra_data.site_id].name || 'Все проекты'
                    }}</p>
                  <p v-if="record.extra_data.disabled_on_project" class="mb-0 badge badge-warning">
                    выключен на сайте
                  </p>
                </td>
                <td>{{ printDrug(record) }}
                  <div v-if="record.comments">
                    <p><i>{{ record.comments.comment }}</i></p>
                    <p class="text-muted text-right">{{ printDate(record.created_at, 'DD.MM.YYYY HH:mm') }}
                      ({{ record.comments.user_id }}) {{ record.comments.user_name }}</p>
                  </div>
                </td>
                <td>{{ moment(record.actual_date, 'DD.MM.YYYY') }}</td>
                <td>
                  <button @click="confirmDelete(record)" type="button" class="btn btn-danger btn-sm"><i
                    class="icon-fa icon-fa-trash"></i></button>
                </td>
              </tr>
              </tbody>
            </table>

            <div v-if="paginator">
              Всего записей: <strong>{{ paginator.total }}</strong>
              <div class="pull-right">
                <paginate
                  v-model="paginator.current_page"
                  :page-count="paginator.last_page"
                  :page-range="3"
                  :margin-pages="2"
                  :click-handler="getRecords"
                  :prev-text="'&laquo'"
                  :next-text="'&raquo'"
                  :container-class="'pagination'"
                  :prev-class="'page-item'"
                  :prev-link-class="'page-link'"
                  :page-class="'page-item'"
                  :page-link-class="'page-link'"
                  :next-class="'page-item'"
                  :next-link-class="'page-link'"
                  :active-class="'active green_btn'">
                </paginate>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import api from '@/api'
import Paginate from 'vuejs-paginate'
import VueLadda from 'vue-ladda/src/vue-ladda.vue'
import customModal from '@/components/modals/customModal'
import moment from 'moment';
import DateSelect from "../../views/reports/components/DateSelect";
import DrugSearchNew from "@/components/drugs/DrugSearchNew";

export default {
  title: 'Черный список (выгрузки)',
  components: {
    Paginate,
    customModal,
    VueLadda,
    DateSelect,
    DrugSearchNew,
  },
  data() {
    return {
      noActualDate: false,
      disableOnProject: false,
      loading: false,
      createLoading: false,
      loadingColor: this.$constants.LOADING_COLOR,
      records: null,
      paginator: null,
      uploadCatalogs: [],
      modalData: false,
      drugData: {
        comment: '',
        date: moment().add(1, 'month').format('DD.MM.YYYY')
      },
      new_record: {
        catalog_id: 0,
        site_id: 0
      },
      filter: {
        catalog_id: 0,
        site_id: 0
      }
    }
  },
  computed: {
    $AllProjects() {
      return this.$store.getters['platform/projects'].reduce((acc, p) => {
        if (p.id != 0) {
          acc[p.id] = p
        }
        return acc;
      }, {});
    },
  },
  mounted() {
    this.getRecords();
  },
  methods: {
    async getRecords(page = 1) {
      this.records = this.paginator = null;
      this.loading = true;
      let filter = '';
      Object.keys(this.filter).forEach((k, i) => {
        if (this.filter[k] && this.filter[k] != 0) filter += '&' + k + '=' + this.filter[k];
      });
      let {data: r_data} = await api.index('/uploads/blacklist?page=' + page + filter);
      if (!r_data.success) {
        toastr['warning']('Ошибка загрузки!');
        return;
      }
      const {data, ...pagination} = r_data.records;
      this.paginator = pagination;
      this.uploadCatalogs = r_data.uploadCatalogs;
      this.records = data;
      this.loading = false;
    },
    printDrug(record) {
      if (record.drug) {
        return record.drug.title;
      }
      if (record.egk1) {
        return record.egk1.prep;
      }
      if (record.egk2) {
        return record.egk2.prep;
      }
    },
    async newRecord() {
      const drug = this.$refs.drugSelected.drug;
      if (!drug || !drug.id) {
        toastr['warning']('Препарат не выбран');
        return;
      }

      if (!this.drugData.comment) {
        toastr['warning']('Комментарий обязателен для добавления в список');
        return;
      }

      if (!this.noActualDate && !moment(this.$refs.selectedDate.date, 'DD.MM.YYYY', true).isValid()) {
        toastr['warning']('Дата актуальности не валидна');
        return;
      }

      this.createLoading = true;
      let {data} = await api.post('/uploads/addToBlackList', {
        drug,
        drugData: {...this.drugData, date: this.$refs.selectedDate && this.$refs.selectedDate.date},
        site_id: this.new_record.site_id,
        catalog_id: this.new_record.catalog_id,
        disableOnProject: this.disableOnProject,
      });
      if (data.success) {
        toastr['success'](data.message || 'Сохранено');
        this.drugData = {
          comment: '',
          date: moment().add(1, 'month').format('DD.MM.YYYY')
        };
        await this.getRecords(this.paginator.current_page);
      } else {
        toastr['warning'](data.message || 'Ошибка сохранения');
      }
      this.createLoading = false;
    },
    closeModal() {
      this.modalData = false;
    },
    async removeRecord() {
      let {data} = await api.post('/uploads/removeFromBlackList', {
        record_id: this.modalData.recordId
      });
      if (data.success) {
        toastr['success'](data.message || 'Сохранено');
        await this.getRecords(this.paginator.current_page);
      } else {
        toastr['warning'](data.message || 'Ошибка сохранения');
      }
      this.closeModal();
    },
    confirmDelete(record) {
      this.modalData = {
        recordId: record.id,
        header: 'Удалить из черного списка?',
        body: '<p>препарат: <strong>' + this.printDrug(record) + '</strong></p><p>Будет удален из черного списка</p>',
        acceptBtnText: 'Подтвердить'
      };
    },
    moment: function (date, format = 'DD.MM.YYYY') {
      if (!date) return;
      return moment(date).format(format);
    },
  }
}

</script>

<style scoped>
table p {
  margin-bottom: 2px;
}

.as_t {
  align-self: flex-start;
}

.min-w-180 {
  min-width: 180px;
}

.mw_50 {
  width: -webkit-fill-available;
  /*min-width: 50%;*/
}

.elements-m-2 div {
  margin-right: 5px;
}

.as_b {
  align-self: flex-end;
}
</style>
